import React from "react";
import { MergeComponents } from "../MergeComponents";
import { ChangePass } from "./ChangePass";

function ChangePassParent() {
    return (
        <>
            <MergeComponents getComponent={<ChangePass/>} />
        </>
    )
}
export { ChangePassParent }